// ~/presentation/hooks/useCheckSession.js
import { useContext, useEffect } from "react";
import AppContext from "~/presentation/AppContext";
import { HttpClient } from "~/infra/http-client";
import { apiURL } from "~/data/usecases/api";
import { useDialog } from "~/presentation/providers/DialogProvider";

const httpClient = new HttpClient(apiURL);

export function useSessionCheck(enabled = true) {
  const { isLogged, handleLogout } = useContext(AppContext);
  const { closeLoginDialog } = useDialog();

  // The http-client interceptor dispatches "unauthorized" on any 401 response.
  // Here we listen to that event to perform the logout + dialog cleanup.
  useEffect(() => {
    const onUnauthorized = () => {
      closeLoginDialog();
      handleLogout();
    };
    window.addEventListener("unauthorized", onUnauthorized);
    return () => window.removeEventListener("unauthorized", onUnauthorized);
  }, [closeLoginDialog, handleLogout]);

  useEffect(() => {
    if (!enabled || !isLogged()) return;

    const token = localStorage.getItem("GT_token");
    if (token) httpClient.setAuthorization(token);

    const checkSession = async () => {
      // Errors on 401 are handled globally by the http-client interceptor.
      // No need to re-dispatch the event here.
      await httpClient.request({ url: `${apiURL}/api/Check`, method: "GET" }).catch(() => {});
    };

    checkSession();
    const id = setInterval(checkSession, 7000);
    return () => clearInterval(id);
  }, [enabled, isLogged]);
}
